import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { getOrgId } from "utils/storage";

import Paths from "./paths";
import * as Types from "./types";

export const branchListService = (params: Types.BranchListRequest) =>
  RestAPIClient.call<Types.BranchListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const branchListShortService = (params: Types.BranchListRequest) =>
  RestAPIClient.call<Types.BranchListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const branchCreateService = (params: Types.BranchCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const branchDetailService = (id: number) =>
  RestAPIClient.call<Types.Branch>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail.replace("{OrgId}", getOrgId())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const branchUpdateService = (params: Types.BranchUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace("{OrgId}", getOrgId())}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
